import { Notify, Report } from 'notiflix';
import React, { useEffect, useState } from 'react'
import Balota from '../../../components/game/Balota';
import BalotaContent from '../../../components/game/BalotaContent';
import styled from "styled-components";

const Resultado = ({
    result,
    game,
    confirmHit,
    handleOpen,
    setCodeWin
}) => {
    const [move1, setMove1] = useState('$');
    const [move2, setMove2] = useState('$');
    const [move3, setMove3] = useState('$');
    const [move4, setMove4] = useState('$');
    const [move5, setMove5] = useState('$');
    const [move6, setMove6] = useState('$');

    const [class1, setClass1] = useState('');
    const [class2, setClass2] = useState('');
    const [class3, setClass3] = useState('');
    const [class4, setClass4] = useState('');
    const [class5, setClass5] = useState('');
    const [class6, setClass6] = useState('');

    useEffect(() => {
        if (result?.move1) {
            setMove1('');
            setMove2('');
            setMove3('');
            setMove4('');
            setMove5('');
            setMove6('');

            setClass1('');
            setClass2('');
            setClass3('');
            setClass4('');
            setClass5('');
            setClass6('');
            aleatorBalls()
        }
    }, [result]);

    const aleatorBalls = () => {
        var iterador = 1;
        var characters = "BINGO1234567890";

        var each = setInterval(function () {
            var each2 = setInterval(() => {
                var ball = characters.charAt(Math.floor(Math.random() * characters.length));
                eval(`setMove${iterador}(ball)`);
            }, 30);

            setTimeout(function () {
                clearInterval(each2);
                if (game['move' + iterador] == result['move' + iterador]) {
                    eval(`setClass${iterador}("hit")`);
                }
                eval(`setMove${iterador}(result['move${iterador}'])`);
                iterador++;
            }, 860);
        }, [870]);

        setTimeout(function () {
            clearInterval(each);
        }, 5220);

        setTimeout(function () {
            const { win, need_access, title, message } = confirmHit;

            if (win) {
                if (need_access) {
                    setCodeWin(game?.code);
                    Report.success(title, message, 'Ok', handleOpen);
                } else {
                    Report.success(title, message, 'Ok');
                }
            } else {
                Notify.failure(message || 'Operación fallida');
            }
        }, 6090);
    }

    return (
        <TopRow>
            <BallWrap>
                <Balota move={move1} classHit={class1} />
            </BallWrap>
            <BallWrap>
                <Balota move={move2} classHit={class2} />
            </BallWrap>
            <BallWrap>
                <Balota move={move3} classHit={class3} />
            </BallWrap>
            <BallWrap>
                <Balota move={move4} classHit={class4} />
            </BallWrap>
            <BallWrap>
                <Balota move={move5} classHit={class5} />
            </BallWrap>
            <BallWrap>
                <Balota move={move6} classHit={class6} />
            </BallWrap>
        </TopRow>
    )
}

export default Resultado

const TopRow = styled.div`
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: clamp(8px, 2vw, 14px);
  align-items: center;
`;

const BallWrap = styled.div`
  /* obliga a ser cuadrado y centrado */
  width: 100%;
  aspect-ratio: 1 / 1;
  max-width: 74px; /* controla tamaño en desktop */
  justify-self: center;
  display: grid;
  place-items: center;

  /* “look” redondo por si Balota no lo aplica */
  border-radius: 999px;

  /* Si Balota renderiza IMG/SVG/DIV internos, los forzamos */
  & > * {
    width: 100% !important;
    height: 100% !important;
    border-radius: 999px !important;
  }

  /* Si dentro hay img o svg */
  img,
  svg {
    width: 100% !important;
    height: 100% !important;
    border-radius: 999px !important;
    object-fit: contain;
    display: block;
  }

  @media (max-width: 600px) {
    max-width: 58px; /* más pequeño en móvil */
  }
`;